

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface LanguagesParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface Languages {
    id?: number;
    name: string;
    languageCode?:string;
    isActive?:boolean;
  parameters?: LanguagesParameter[];
  links?: any;
}

export abstract class LanguagesData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<Languages[]>;
  abstract create(url: string,data: Languages): Observable<any>;
  abstract update(url: string,data: Languages): Observable<any>;
  abstract delete(url: string): Observable<any>;
}